export default __webpack_public_path__ + "static/media/ESP.8ccb1034.svg";